"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const General_1 = require("../types/General");
const appStateSelectControlByIdFromBO_1 = __importDefault(require("./appStateSelectControlByIdFromBO"));
const appStateSelectControlByIdFromFC_1 = __importDefault(require("./appStateSelectControlByIdFromFC"));
const appStateSelectControlTagById = (controlId) => (state) => {
    if (!controlId) {
        return undefined;
    }
    const controlBase = (0, appStateSelectControlByIdFromBO_1.default)(controlId)(state);
    if (controlBase) {
        return controlBase[General_1.DEFINITION_PROP_NAMES.TAG];
    }
    const flatControl = (0, appStateSelectControlByIdFromFC_1.default)(controlId)(state);
    return flatControl === null || flatControl === void 0 ? void 0 : flatControl.tag;
};
exports.default = appStateSelectControlTagById;
